import { fontSizeUnderCursor } from '../extensions/_font_size_helpers';

const getCurrentFontSize = (editor) => {
  const fontSize = editor.getAttributes('textStyle').fontSize;
  return parseInt(fontSize, 10) || fontSizeUnderCursor(editor);
};

const setFontSize = (editor, { value: fontSize }) => {
  const size = parseInt(fontSize, 10) || 12;
  editor.chain().focus().setFontSize(`${size}pt`).run();
};

const unsetFontSize = (editor) => {
  editor.chain().focus().unsetFontSize().run();
};

const increaseFontSize = (editor) => {
  const nextFontSize = getCurrentFontSize(editor) + 1;
  editor.chain().focus().setFontSize(`${nextFontSize}pt`).run();
};

const decreaseFontSize = (editor) => {
  const previousSize = getCurrentFontSize(editor) - 1;
  const previousFontSize = Math.max(1, previousSize);
  editor.chain().focus().setFontSize(`${previousFontSize}pt`).run();
};

export default {
  'font:size:set': setFontSize,
  'font:size:unset': unsetFontSize,
  'font:size:increase': increaseFontSize,
  'font:size:decrease': decreaseFontSize,
};
